import { siteInfo } from "@/mocks/comics";

export default function About() {
  return (
    <main>
      <section className="pt-24 pb-10 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1
            className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            关于我们
          </h1>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            致力于为<strong>韩国漫画</strong>爱好者提供最优质的推荐服务
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center mb-16">
            <div>
              <h2
                className="text-xl md:text-2xl font-bold text-foreground-950 mb-4"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                品牌故事
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {siteInfo.name}成立于{siteInfo.foundedYear}年，是国内最早专注于<strong>韩国漫画</strong>推荐的专业平台之一。我们的创始团队由一群热爱韩国漫画的资深读者组成，因为发现国内缺少系统性的<strong>韩国漫画</strong>推荐资源，于是创立了这个平台。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                从最初的个人博客发展到如今的综合性<strong>韩国漫画推荐</strong>网站，我们始终坚持做一件事——用专业、客观、用心的态度，帮助每一位读者找到最适合自己的<strong>韩国漫画</strong>。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                截至目前，我们已经累计推荐<strong>{siteInfo.totalRecommendations}</strong>部优质韩国漫画作品，覆盖恋爱、奇幻、悬疑、搞笑、古风等全部主流类型。
              </p>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20culture%20cozy%20library%20corner%20with%20books%20and%20tablet%2C%20warm%20lighting%2C%20minimalist%20interior%2C%20reading%20atmosphere%2C%20cream%20tones%2C%20artistic%20still%20life%20photography&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                alt="韩国漫画推荐 - 品牌故事"
                className="w-full h-64 md:h-80 object-cover rounded-xl"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-16">
            {[
              { value: siteInfo.totalRecommendations, label: "累计推荐" },
              { value: siteInfo.monthlyVisitors, label: "月度访客" },
              { value: siteInfo.expertReviewers, label: "专业评审" },
              { value: `${new Date().getFullYear() - 2020}+`, label: "年行业经验" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="text-center p-5 bg-background-100 rounded-xl border border-background-200/70"
              >
                <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="mb-16">
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              为什么选择我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                {
                  icon: "ri-shield-check-line",
                  title: "专业评审",
                  desc: `每部<strong>韩国漫画</strong>都经过专业评审团队多维度评估，确保推荐质量`,
                },
                {
                  icon: "ri-refresh-line",
                  title: "持续更新",
                  desc: "每日追踪最新连载，第一时间更新<strong>韩国漫画排行榜</strong>",
                },
                {
                  icon: "ri-heart-line",
                  title: "用心推荐",
                  desc: "不追求数量，只推荐真正值得看的<strong>好看的韩国漫画</strong>",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-6 bg-background-100 rounded-xl border border-background-200/70 text-center"
                >
                  <span className="w-12 h-12 flex items-center justify-center mx-auto mb-4 bg-primary-100 text-primary-600 rounded-xl">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p
                    className="text-xs text-foreground-500 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <span className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </span>
                  <div>
                    <h4 className="font-medium text-sm text-foreground-950 mb-1">电子邮件</h4>
                    <a
                      href={`mailto:${siteInfo.email}`}
                      className="text-sm text-foreground-500 no-underline hover:text-primary-600 transition-colors"
                    >
                      {siteInfo.email}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </span>
                  <div>
                    <h4 className="font-medium text-sm text-foreground-950 mb-1">工作时间</h4>
                    <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  <div>
                    <h4 className="font-medium text-sm text-foreground-950 mb-1">我们的使命</h4>
                    <p className="text-sm text-foreground-500">
                      让每一位<strong>韩国漫画</strong>爱好者都能找到属于自己的那部作品
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6">
                <h3 className="font-semibold text-foreground-950 mb-4">给我们留言</h3>
                <form
                  data-readdy-form="true"
                  action="https://readdy.ai/api/form/d9omt92qs38sj6jc7bk0"
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  className="space-y-3"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypot = formData.get("website_alt");
                    if (honeypot && String(honeypot).trim() !== "") {
                      const el = form.querySelector(".form-status");
                      if (el) el.innerHTML = "<p class='text-sm text-accent-600'>留言已发送，我们会尽快回复！</p>";
                      return;
                    }
                    formData.delete("website_alt");
                    try {
                      const res = await fetch(form.action, {
                        method: "POST",
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      });
                      const text = await res.text();
                      let msg = "留言已发送，我们会尽快回复！";
                      let isError = false;
                      try {
                        const parsed = JSON.parse(text);
                        if (parsed.code === "OK") {
                          form.reset();
                        } else if (parsed.meta?.message && parsed.meta.message.includes("spam")) {
                          msg = parsed.meta.message;
                          isError = true;
                        } else {
                          msg = parsed.meta?.message || parsed.message || text;
                          isError = parsed.code !== "OK";
                        }
                      } catch {
                        if (!res.ok) {
                          msg = text || "发送失败，请稍后重试";
                          isError = true;
                        }
                      }
                      const el = form.querySelector(".form-status");
                      if (el) el.innerHTML = `<p class='text-sm ${isError ? "text-red-500" : "text-accent-600"}'>${msg}</p>`;
                    } catch {
                      const el = form.querySelector(".form-status");
                      if (el) el.innerHTML = "<p class='text-sm text-red-500'>网络错误，请稍后重试</p>";
                    }
                  }}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="您的称呼"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言（最多500字）"
                    maxLength={500}
                    rows={3}
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  ></textarea>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送留言
                  </button>
                  <div className="form-status"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: `关于我们 - ${siteInfo.name}`,
            description: siteInfo.description,
            url: "https://koreancomics.cn/about",
            about: {
              "@type": "Organization",
              name: siteInfo.name,
              description: siteInfo.description,
              foundingDate: siteInfo.foundedYear,
              email: siteInfo.email,
            },
          }),
        }}
      />
    </main>
  );
}